export const KEY_CONFIG = {
  'enter': 13,
  'space': 32,
  'arrowUp': 38,
  'arrowDown': 40,
  'arrowLeft': 37,
  'arrowRight': 39,
  'tabKey': 9,
  'escapeKey': 27,
  'backSpaceKey': 8,
  'numericKey9': 57,
  'numericKey0': 48,
  'home': 36,
  'end': 35,
  'firstSmallAlphabet': 65,
  'lastSmallAlphabet': 90
};
